const initialState = {
    turnCount: 2,
    allDataLoaded: false,
    gameExists: null,
    extraCreditExists: null,
    gameData: {},
    currentCard: {},
    currentCardLoaded: false,
    eventConditions: [],
    pictureInfo: "",
    backgroundURL: "",
    funStuffInfo: "",
    savingsInfo: {},
    creditCardInfo: {},
    timeWizardInfo: {},
    gamePurchases: {},
    friendInfo: [],
    activityTracker: {},
    gamePhase: "",  
    cardInProcess: false,
    cardImageObj: {},
    cardList: [],
    extraCredit: {},
    playerRole: "",
    totalGameMonths: 0,
    friendCardInfo: {},
    moneyMgmtTestArr: [],
    prevNextMonth: {},
    prevProcess: "",
    eventCount: 0,
    eventTrackerNbr: 0,
    activityCategory: "none",
    gameInvestments: [],
    investmentMaster: [],
    notificationArr: [],
    summaryInvestment: [],
    bondBuyTrans: [],
    refreshInvestments: false,
    shortNameArr: [],
    savingInterestRates: [],
    companyMatchRate: "0",
    retirementPriceArr: [],
    testFlag: "",
    eligibleForCouponsDividends: false,
    accountSettings: {},
    creditReport: {},
    userAccountNbr: "",
    gameSettings: {}
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INCREMENT':
            return {
                ...state,
                turnCount: state.turnCount + 1
            };
        case 'INCREMENTEVENTTRACKER':
            return {
                ...state,
                eventTrackerNbr: state.eventTrackerNbr + 1
            };
        case "SETGAMEDATA":
            return {
                ...state,
                gameData: {
                    ...state.gameData,         // copy existing gameData
                    [action.dataName]: action.payload  // override the specific field
                }
            };
        case 'SETINFO':
            return {
                ...state,
                [action.dataName]: action.payload
            };   
        case "INITIALIZE":
            return {
               ...initialState,
               cardList: [],
            }
        default:
            return state;
    };
};

